import { TViewMode } from '../../ProjectsOnMap/ProjectsOnMap';
import { IOffice } from '../../../types/offices';

interface IHandleOfficePhoneArguments {
  mode: TViewMode;
  officeId: string;
  officesHash: Record<string, IOffice>;
}

export function handleOfficePhone({ mode, officeId, officesHash }: IHandleOfficePhoneArguments) {
  // istanbul ignore if
  if (mode !== 'offices') {
    return;
  }

  const callbackButton = document.getElementById(officeId);

  // istanbul ignore else
  if (callbackButton) {
    callbackButton.onclick = () => {
      const officePhone = officesHash[officeId].preparedPhone;
      // Если номера не будет, то кнопка не отрендерится и условие выше не выполнится
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const phoneNode = createOfficePhoneNode(officePhone!);

      callbackButton.replaceWith(phoneNode);
    };
  }
}

export function createOfficePhoneNode(phone: string) {
  const span = document.createElement('span');
  span.textContent = phone;

  return span;
}
